webpackJsonp([189811098337614],{

/***/ 471:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.SheShines = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(18);
	
	var _Heading = __webpack_require__(7);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _contentPage = __webpack_require__(4);
	
	var _contentPage2 = _interopRequireDefault(_contentPage);
	
	var _meta = __webpack_require__(5);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFacebookPixel = __webpack_require__(9);
	
	var _reactFacebookPixel2 = _interopRequireDefault(_reactFacebookPixel);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Modal = __webpack_require__(8);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _reactSlick = __webpack_require__(15);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	__webpack_require__(13);
	
	__webpack_require__(12);
	
	var _reactLinkedinInsight = __webpack_require__(16);
	
	var _reactLinkedinInsight2 = _interopRequireDefault(_reactLinkedinInsight);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var icon1 = "https://winpeforum.com/assets/elements/VandanaPai.jpg";
	var icon2 = "https://winpeforum.com/assets/elements/Nishanth-Ravindran.png";
	var duration = 400;
	
	var I1 = "https://www.winpeforum.com/assets/wob/4dec2025/1.png";
	var I2 = "https://www.winpeforum.com/assets/wob/4dec2025/2.png";
	var I3 = "https://www.winpeforum.com/assets/wob/4dec2025/3.png";
	var I4 = "https://www.winpeforum.com/assets/wob/4dec2025/4.png";
	var I5 = "https://www.winpeforum.com/assets/wob/4dec2025/5.png";
	var I6 = "https://www.winpeforum.com/assets/wob/4dec2025/6.png";
	var I7 = "https://www.winpeforum.com/assets/wob/4dec2025/7.png";
	var I8 = "https://www.winpeforum.com/assets/wob/4dec2025/8.png";
	var I9 = "https://www.winpeforum.com/assets/wob/4dec2025/9.png";
	var I10 = "https://www.winpeforum.com/assets/wob/4dec2025/10.png";
	var I11 = "https://www.winpeforum.com/assets/wob/4dec2025/11.png";
	var I12 = "https://www.winpeforum.com/assets/wob/4dec2025/12.png";
	
	var II1 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/1.png";
	var II2 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/2.png";
	var II3 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/3.png";
	var II4 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/4.png";
	var II5 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/5.png";
	var II6 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/6.png";
	var II7 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/7.png";
	var II8 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/8.png";
	var II9 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/9.png";
	var II10 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/10.png";
	var II11 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/11.png";
	var II12 = "https://www.winpeforum.com/download.php?file=assets/wob/4dec2025/12.png";
	
	var TeamModal = function TeamModal(_ref) {
	  var activeItem = _ref.activeItem,
	      show = _ref.show,
	      onHide = _ref.onHide;
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    {
	      direction: "",
	      className: "teamdetails__wrapper",
	      show: show,
	      onHide: onHide
	    },
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "head_section" },
	        _react2.default.createElement(
	          "span",
	          { className: "item_name" },
	          activeItem.name
	        ),
	        _react2.default.createElement("div", {
	          className: "item_des",
	          dangerouslySetInnerHTML: { __html: activeItem.post }
	        })
	      ),
	      _react2.default.createElement(
	        "span",
	        { className: "cross pull-right" },
	        _react2.default.createElement("i", { onClick: onHide, className: "fa fa-times" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "item__desc" },
	        _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: activeItem.desc } })
	      )
	    ),
	    _react2.default.createElement(_Modal2.default.Footer, null)
	  );
	};
	
	TeamModal.propTypes = {
	  activeItem: _propTypes2.default.object,
	  show: _propTypes2.default.object,
	  onHide: _propTypes2.default.object
	};
	
	var SheShines = exports.SheShines = function (_React$Component) {
	  _inherits(SheShines, _React$Component);
	
	  function SheShines(args) {
	    _classCallCheck(this, SheShines);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, args));
	
	    _this.updateWindowDimensions = function () {
	      var slidesToShow = _this.state.slidesToShow;
	      // // console.log("width", window.innerWidth)
	
	      if (window.innerWidth <= 768 && window.innerWidth > 500) {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      } else if (window.innerWidth <= 500) {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      } else {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      }
	    };
	
	    _this.togglePopUp = function (item) {
	      _this.setState({
	        isShow: !_this.state.isShow,
	        activeItem: item || {}
	      });
	    };
	
	    _this.state = {
	      slidesToShow: 1,
	      activeItem: {},
	      isShow: false,
	      defaultStyle: {
	        transition: "opacity " + duration + "ms ease-in-out",
	        opacity: 0
	      }
	    };
	
	    _this.Speaker1 = [{
	      imgUrl: icon2,
	      desc: " ",
	      name: "Nishanth Ravindran",
	      post: "<div>Partner<br/>AZB & Partners\n\n\n\n\n          </div>"
	    }];
	
	    _this.Speaker2 = [{
	      imgUrl: icon2,
	      desc: "Alka Goel is the Founder of Alkemi Growth Capital LLP, an early stage healthcare and consumer wellness fund. She has led investment in multiple sub-sectors over the last 6 years. Prior to that, Alka was a Partner in McKinsey & Co., New York office, where she primarily served clients in the life science and private equity industry.\n<br/><br/>\nAt McKinsey, she served more than 350 Clients across all major geographies. She completed her business school from Indian Institute of Management, Ahmedabad in 2000 and Bachelor of Economics from Lady Shri Ram College, Delhi University.\n\n\n         ",
	      name: "Alka Goel",
	      post: "<div>Founding Partner<br/> Alkemi Growth Capital\n        </div>"
	    }];
	    _this.CollegiumsImages = [{ id: 23, ImgSrc: I1, ImgSrc1: II1 }, { id: 35, ImgSrc: I2, ImgSrc1: II2 }, { id: 22, ImgSrc: I3, ImgSrc1: II3 }, { id: 19, ImgSrc: I4, ImgSrc1: II4 }, { id: 35, ImgSrc: I5, ImgSrc1: II5 }, { id: 34, ImgSrc: I6, ImgSrc1: II6 }, { id: 23, ImgSrc: I7, ImgSrc1: II7 }, { id: 35, ImgSrc: I8, ImgSrc1: II8 }, { id: 22, ImgSrc: I9, ImgSrc1: II9 }, { id: 19, ImgSrc: I10, ImgSrc1: II10 }, { id: 35, ImgSrc: I11, ImgSrc1: II11 }, { id: 34, ImgSrc: I12, ImgSrc1: II12 }];
	
	    return _this;
	  }
	
	  SheShines.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this.updateWindowDimensions();
	    window.addEventListener("resize", this.updateWindowDimensions);
	    _reactFacebookPixel2.default.init("2879175222167037");
	    _reactFacebookPixel2.default.track("ViewContent", location);
	    _reactLinkedinInsight2.default.init("2117884");
	    _reactLinkedinInsight2.default.track("2310748");
	    setTimeout(function () {
	      _this2.setState({
	        defaultStyle: {
	          transition: "opacity " + duration + "ms ease-in-out",
	          opacity: 1
	        }
	      });
	    }, 500);
	  };
	
	  SheShines.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener("resize", this.updateWindowDimensions);
	  };
	
	  SheShines.prototype.render = function render() {
	    var _this3 = this;
	
	    var _state = this.state,
	        defaultStyle = _state.defaultStyle,
	        isShow = _state.isShow,
	        slidesToShow = _state.slidesToShow;
	    var location = this.props.location;
	
	    var settings = {
	      dots: false,
	      infinite: true,
	      speed: 6000,
	      autoplay: true,
	      slidesToShow: slidesToShow,
	      slidesToScroll: slidesToShow,
	      autoplaySpeed: 7000,
	      arrows: true
	    };
	    console.log("render", this.render1, slidesToShow);
	    this.render1 = this.render1 + 1;
	    return _react2.default.createElement(
	      _contentPage2.default,
	      null,
	      _react2.default.createElement(_meta2.default, {
	        title: "Women on Boards",
	        image: "https://winpeforum.com/assets/wob/banner.jpg",
	        description: "Winpe\u2019s Women on Boards initiative hosted another exceptional session marked by profound insights, engaging discussions, and inspiring connections. We are pleased to report that the session received outstanding evaluations\u2014100% of participants acknowledged significant knowledge gains, and our speakers were rated exceptionally well at 4.5.",
	        location: location
	      }),
	      _react2.default.createElement(
	        "div",
	        { className: "section__content", style: defaultStyle },
	        _react2.default.createElement(
	          "div",
	          { className: "toastshine_wrapper" },
	          _react2.default.createElement(
	            "div",
	            { className: "back_event" },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/events/" },
	              _react2.default.createElement(
	                "i",
	                { className: "fa fa-arrow-left" },
	                "Back to Events"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "toastshine_section" },
	            _react2.default.createElement(
	              "div",
	              { className: "m_heading" },
	              "        Winpe\u2019s Women on Boards",
	              _react2.default.createElement("br", null),
	              "Topic: Decoding India\u2019s Labour Codes-Boardroom Perspective"
	            ),
	            _react2.default.createElement("div", { className: "r_btm" }),
	            _react2.default.createElement(
	              "div",
	              { className: "date_heading" },
	              _react2.default.createElement(
	                "div",
	                { className: "date_heading" },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  "September 4th, 2026 (04:00 - 05:00 PM IST)",
	                  _react2.default.createElement("br", null),
	                  "Format- Virtual (Zoom)"
	                )
	              )
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "div",
	              { className: "top_text", style: { textAlign: 'justify' } },
	              "Winpe\u2019s Women on Boards initiative is reshaping board leadership by advancing high-caliber, board-ready women. Through partnerships with progressive companies and targeted board-prep programs, it offers curated talent and strategic engagement models that strengthen governance and support DEI goals.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "The recent session on \u201CDecoding India\u2019s Labour Codes \u2013 Boardroom Perspective,\u201D led by Nishanth Ravindran, AZB & Partners, offered senior women leaders a concise and insightful view of the four Labour Codes and their implications for governance, workforce strategy, financial exposure, and board oversight.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "With the Labour Codes effective from November 21, 2025, and the Central Rules notified on May 8, 2026, the session focused on the key shifts boards need to understand as organisations navigate implementation.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "The session received excellent feedback from participants, who appreciated the practical insights, clarity of the discussion, and its strong relevance to board-level decision-making.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "Catch the full recording ",
	              _react2.default.createElement(
	                "a",
	                { style: { textDecoration: 'underline', color: 'blue' }, href: "youtu.be/vrWFqS21-C4" },
	                "here"
	              ),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "Join our Women on Boards community to access curated board opportunities and stay informed on upcoming sessions, insights, and engagements through our WhatsApp group.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "\uD83D\uDC49 ",
	              _react2.default.createElement(
	                "a",
	                { style: { textDecoration: 'underline', color: 'blue' }, href: "https://tally.so/r/wv9OJX" },
	                "Join our peer community"
	              ),
	              "    \xA0\xA0\xA0\xA0\uD83D\uDC49          ",
	              _react2.default.createElement(
	                "a",
	                { style: { textDecoration: 'underline', color: 'blue' }, href: "https://chat.whatsapp.com/CYRLOvnGjyeJgd45frXkwf?s=cl&p=a&ilr=1" },
	                "Join the WhatsApp Group"
	              ),
	              _react2.default.createElement("br", null),
	              " ",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "h3",
	                null,
	                _react2.default.createElement(
	                  "b",
	                  null,
	                  "Session Takeaways: "
	                )
	              ),
	              _react2.default.createElement(
	                "ul",
	                null,
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Board Accountability:"
	                  ),
	                  " Labour compliance is increasingly a board-level governance and risk issue, with potential liability extending to directors in certain circumstances."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Wage Definition:"
	                  ),
	                  " The revised definition of \u201Cwages\u201D has direct implications for gratuity, leave encashment, and retrenchment liabilities, making it a key financial consideration for boards."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Immediate Readiness:"
	                  ),
	                  " Organisations need to assess their compensation structures, employee benefit liabilities and processes, including the requirement for full-and-final settlement within two working days."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Defensible Compliance Frameworks:"
	                  ),
	                  " Compliance must be demonstrable through comprehensive documentation, embedded controls, regular audits, and strong audit trails to withstand regulatory scrutiny."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Workforce Strategy:"
	                  ),
	                  " Changes relating to fixed-term employment, retrenchment and contract labour have implications for workforce planning, restructuring and operating models."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Future of Work:"
	                  ),
	                  " The inclusion of gig and platform workers within the social-security framework signals an evolving employment landscape that boards need to factor into long-term workforce strategy."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Employee Governance:"
	                  ),
	                  " Grievance redressal, workplace safety, working hours and employee welfare are increasingly important elements of responsible workforce governance."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Gender & Inclusion:"
	                  ),
	                  " The Codes reinforce the need for equitable employment practices, providing boards an opportunity to strengthen their focus on gender equity, workplace participation and inclusive workforce policies."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "State-Level Readiness:"
	                  ),
	                  " While substantive provisions are actionable, state-level rules remain an evolving area. Organisations operating across multiple states need to maintain regulatory readiness and monitor developments closely."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Risk & Compliance:"
	                  ),
	                  " Boards should seek clear management assurance on compliance readiness, documentation, controls and emerging liabilities."
	                )
	              ),
	              _react2.default.createElement(
	                "h3",
	                null,
	                _react2.default.createElement(
	                  "b",
	                  null,
	                  "The Boardroom Perspective"
	                )
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "The Labour Codes represent more than a regulatory change. They have strategic implications for people, cost, risk and business resilience. For senior women leaders, understanding these shifts strengthens their ability to challenge management, oversee workforce risk, and contribute meaningfully to board-level decision-making."
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "row" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12" },
	                  _react2.default.createElement(
	                    "h2",
	                    { "class": "ignite-ask-me-anything__heading", style: { fontSize: "30px" } },
	                    "Faculty"
	                  ),
	                  "          ",
	                  _react2.default.createElement("div", { "class": "r_btm" }),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "Our_Speakers container" },
	                    _react2.default.createElement(
	                      "center",
	                      null,
	                      _react2.default.createElement(
	                        "div",
	                        { className: "Speakers_img", style: { width: '70%', margin: '0' } },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          this.Speaker1.map(function (item, i) {
	                            if (i <= 3) {
	                              return _react2.default.createElement(
	                                "div",
	                                {
	                                  className: "main_speaker_card col-md-12 col-sm-12 col-lg-12",
	                                  key: i
	                                },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "Scardd" },
	                                  _react2.default.createElement(
	                                    "div",
	                                    {
	                                      className: "s_img",
	                                      onClick: function onClick() {
	                                        return _this3.togglePopUp(item);
	                                      }
	                                    },
	                                    _react2.default.createElement(
	                                      "center",
	                                      null,
	                                      "  ",
	                                      _react2.default.createElement("img", {
	                                        src: item.imgUrl,
	                                        alt: item.name,
	                                        className: "img-responsive",
	                                        style: { borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }
	                                      })
	                                    )
	                                  ),
	                                  _react2.default.createElement("br", null),
	                                  "    ",
	                                  _react2.default.createElement("div", {
	                                    className: "Speakers_name",
	                                    dangerouslySetInnerHTML: { __html: item.name }
	                                  }),
	                                  _react2.default.createElement("div", {
	                                    className: "Speakers_post",
	                                    dangerouslySetInnerHTML: { __html: item.post }
	                                  })
	                                )
	                              );
	                            } else return _react2.default.createElement(
	                              "div",
	                              {
	                                className: "main_speaker_card col-md-3 col-sm-12 col-lg-3",
	                                key: i
	                              },
	                              _react2.default.createElement(
	                                "div",
	                                { className: "Scardd" },
	                                _react2.default.createElement(
	                                  "div",
	                                  {
	                                    className: "s_img",
	                                    onClick: function onClick() {
	                                      return _this3.togglePopUp(item);
	                                    }
	                                  },
	                                  _react2.default.createElement(
	                                    "center",
	                                    null,
	                                    "  ",
	                                    _react2.default.createElement("img", {
	                                      src: item.imgUrl,
	                                      alt: item.name,
	                                      className: "img-responsive",
	                                      style: { borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }
	                                    })
	                                  )
	                                ),
	                                _react2.default.createElement("br", null),
	                                "    ",
	                                _react2.default.createElement("div", {
	                                  className: "Speakers_name",
	                                  dangerouslySetInnerHTML: { __html: item.name }
	                                }),
	                                _react2.default.createElement("div", {
	                                  className: "Speakers_post",
	                                  dangerouslySetInnerHTML: { __html: item.post }
	                                })
	                              )
	                            );
	                          })
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "div",
	              { "class": "container" },
	              _react2.default.createElement("br", null)
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null)
	          ),
	          _react2.default.createElement(TeamModal, {
	            show: isShow,
	            onHide: this.togglePopUp,
	            activeItem: this.state.activeItem
	          })
	        )
	      )
	    );
	  };
	
	  return SheShines;
	}(_react2.default.Component);
	
	SheShines.propTypes = {
	  location: _propTypes2.default.object
	};
	
	exports.default = SheShines;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-wob-decoding-indias-labour-codes-index-js-20866cb76297c4bc5277.js